import React from 'react';
import ScrollableDataTable from '../../../Base/Components/ScrollableDataTable/ScrollableDataTable';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import LaboratoryResultTableItem from './LaboratoryResultTableItem';

export interface ILaboratoryResultListItem {
	id: string;
	createdAt: string;
	name: string;
	result: number;
	unit: string;
	lowerReferenceValue: number;
	upperReferenceValue: number;
	chart: string;
	evaluation: {
		value: number;
		type: string;
		color: string;
	};
	acceptedAt: string;
	acceptedBy: string;
	processedAt: string;
	processedBy: string;
	material: string;
}

interface Props {
	items: ILaboratoryResultListItem[];
	onRowClick?: (item: ILaboratoryResultListItem) => void;
}

const COLUMNS = [
	{
		key: 'createdAt',
		title: 'component.laboratoryResultItemsList.createdAt',
		renderItem: (item: { createdAt: string | null }) => {
			if (!item.createdAt) return <></>;
			return (
				<LaboratoryResultTableItem>
					<FormattedMomentDate
						date={item.createdAt}
						format={DateFormat.DATE_TIME}
					/>
				</LaboratoryResultTableItem>
			);
		},
	},
	{
		key: 'name',
		title: 'component.laboratoryResultItemsList.name',
		renderItem: (item: { name: string }) => {
			return <LaboratoryResultTableItem>{item.name}</LaboratoryResultTableItem>;
		},
	},
	{
		key: 'result',
		title: 'component.laboratoryResultItemsList.result',
		renderItem: (item: {
			evaluation: { value: number; type: string; color: string };
		}) => (
			<LaboratoryResultTableItem
				style={{
					position: 'absolute',
					inset: 0,
					display: 'flex',
					alignItems: 'center',
					backgroundColor: item.evaluation.color,
				}}>
				{item.evaluation.value}
			</LaboratoryResultTableItem>
		),
	},
	{
		key: 'referenceValue',
		title: 'component.laboratoryResultItemsList.referenceValue',
		renderItem: (item: {
			lowerReferenceValue: string;
			upperReferenceValue: string;
		}) => {
			return (
				<LaboratoryResultTableItem>
					<>
						{item.lowerReferenceValue} - {item.upperReferenceValue}
					</>
				</LaboratoryResultTableItem>
			);
		},
	},
	{
		key: 'unit',
		title: 'component.laboratoryResultItemsList.unit',
		renderItem: (item: { unit: string }) => {
			return <LaboratoryResultTableItem>{item.unit}</LaboratoryResultTableItem>;
		},
	},
	{
		key: 'material',
		title: 'component.laboratoryResultItemsList.material',
		renderItem: (item: { material: string }) => {
			return (
				<LaboratoryResultTableItem>{item.material}</LaboratoryResultTableItem>
			);
		},
	},
	{
		key: 'processedBy',
		title: 'component.laboratoryResultItemsList.approvedBy',
		renderItem: (item: { acceptedBy: string; processedAt: string | null }) => {
			if (!item.processedAt) return <></>;
			return (
				<LaboratoryResultTableItem>
					<div>
						<FormattedMomentDate
							date={item.processedAt}
							format={DateFormat.DATE}
						/>{' '}
						{item.acceptedBy}
					</div>
				</LaboratoryResultTableItem>
			);
		},
	},
];

const LaboratoryResultItemsList: React.FC<Props> = ({ items, onRowClick }) => {
	return (
		<ScrollableDataTable
			columns={COLUMNS}
			rows={items}
			firstColumnFixed={false}
			onRowClick={onRowClick}
		/>
	);
};

export default LaboratoryResultItemsList;
